export const ADD_EVENT_MODE = {
  Create: 'Create',
  Edit: 'Edit',
  Copy: 'Copy',
}
